import * as React from 'react';
import type { FieldFormProps } from '@helpcenter/field-types';
import { FormMultiSelect } from '@helpcenter/form-select';
import type { ValueType } from '@atlaskit/select/types';
import type { Option } from '@atlaskit/select';
import { toMultiSelectValue } from '@atlassian/help-center-common-util/select';

type Props = FieldFormProps<string[] | string> & {
	label: string;
	options: Option<string>[];
	valueOverride?: Option<string>;
	defaultValue?: Option<string>[];
};

class MultiFieldSelect extends React.PureComponent<Props> {
	componentDidMount() {
		// PORTAL-2032 - this is required to make url filling (e.g. ?customfield_10343=10657) work
		if (this.props.defaultValue && this.props.defaultValue.length > 0) {
			this.onChange(this.props.defaultValue as unknown as ValueType<Option<string>>);
		}
	}

	onChange = (options: ValueType<Option<string>>, meta?: object) => {
		const selectedOptions = toMultiSelectValue(options);
		// The multiselect field requires that you pass a value in the create request
		// lest Jira applies the default options to it.
		const val = selectedOptions.length !== 0 ? selectedOptions.map((v) => v.value) : '';
		this.props.onChange &&
			this.props.onChange(this.props.id, val, false, {
				rawObject: meta ?? {},
				rawValue: options,
			});
	};

	render() {
		const { disabled, ...otherProps } = this.props;
		return (
			<FormMultiSelect
				{...otherProps}
				actionSubjectId="multiSelectField"
				onChange={this.onChange}
				isDisabled={disabled}
			/>
		);
	}
}

export default MultiFieldSelect;
